import * as utils from '../js/utils';
import {loadStripe, Stripe, StripeElements} from '@stripe/stripe-js';

interface PWindow extends Window {
    pay: {
        api: string
        stripe_publishable_key: string
    }
}
declare const window: PWindow;

class AccountUpdateForm {
    private static stripe: Stripe;
    private readonly elements: StripeElements;

    constructor(elements: StripeElements) {
        this.elements = elements;
    }

    private static returnUrl(props: {subscription_item: string, return_url: string}) {
        const {api} = window.pay;
        return `${ api }/pm/confirm?subscription_item=${ props.subscription_item }&return_url=${ encodeURIComponent(props.return_url) }`;
    }

    static async build(form: HTMLFormElement) : Promise<AccountUpdateForm> {
        if ( ! AccountUpdateForm.stripe ) {
            const stripe = await loadStripe(window.pay.stripe_publishable_key);
            if (stripe) {
                AccountUpdateForm.stripe = stripe;
            } else {
                throw 'Stripe failed to load.';
            }
        }

        const secret = form.dataset.setupIntentClientSecret;
        const appearance = utils.stripeAppearance({form});

        const elements = AccountUpdateForm.stripe.elements({
            clientSecret: secret,
            appearance: appearance
        });

        const paymentElement = elements.create('payment');
        paymentElement.mount('#payment-element');

        return new AccountUpdateForm(elements);
    }

    async submit(event: Event) {
        event.preventDefault();

        const url = new URL(window.location.href);
        url.searchParams.delete('action');

        const subscription_item = url.searchParams.get('subscription_item') || '';

        const {error} = await AccountUpdateForm.stripe.confirmSetup({
            elements: this.elements,
            confirmParams: {
                return_url: AccountUpdateForm.returnUrl({
                    subscription_item,
                    return_url: url.href
                }),
            }
        });

        if (error) {
            utils.showMessage({
                form: event.target,
                message: error.message
            });
        }
    }
}

const firstNavLink = document.querySelector('.payments-nav-link') as HTMLAnchorElement;

function setTab(hash: string) {
    hash = hash ? hash : (firstNavLink ? firstNavLink.hash : '#payments');
    const className = hash.replace('#', 'payments-');
    utils.displayAll('.payments-account .payments-tab-pane', 'none');
    utils.displayAll(`.payments-account .payments-tab-pane.${ className }`);

    utils.removeClassAll('.payments-account .payments-nav-link', 'payments-active');
    const selector = `.payments-account .payments-nav-link[href="${ hash }"]`;
    utils.addClassAll(selector, 'payments-active');
}

export default async function() {
    document.querySelectorAll('*[data-payments-payment-link]').forEach((element) => {
        element.addEventListener('click', function () {
            window.location.search = `?payment=${ (element as HTMLElement).dataset.paymentsPaymentLink }`;
        });
    });

    document.querySelectorAll('*[data-payments-payment-item-link]').forEach((element) => {
        element.addEventListener('click', function () {
            window.location.search = `?payment_item=${ (element as HTMLElement).dataset.paymentsPaymentItemLink }`;
        });
    });

    document.querySelectorAll('*[data-payments-subscription-link]').forEach((element) => {
        element.addEventListener('click', function () {
            window.location.search = `?subscription=${ (element as HTMLElement).dataset.paymentsSubscriptionLink }`;
        });
    });

    document.querySelectorAll('*[data-payments-subscription-item-link]').forEach((element) => {
        element.addEventListener('click', function () {
            window.location.search = `?subscription_item=${ (element as HTMLElement).dataset.paymentsSubscriptionItemLink }`;
        });
    });

    /**/
    let elements = document.querySelectorAll('.payments-account-update-payment-method');
    for (let i = 0; i < elements.length; i++) {
        const account = await AccountUpdateForm.build(elements[i] as HTMLFormElement);
        elements[i].addEventListener('submit', account.submit.bind(account));
    }

    /**/
    elements = document.querySelectorAll('.payments-account .payments-nav-link');
    if (elements.length > 0) {
        setTab(window.location.hash);
        for (let i = 0; i < elements.length; i++) {
            elements[i].addEventListener('click', function (event: Event) {
                setTab((event.target as HTMLAnchorElement).hash);
            });
        }
    }
}